module.exports = __webpack_public_path__ + "img/logo12.e2d8cdb6.png";